export default "__VITE_ASSET__D5phdpt7__"